// latest config.js

import { ValueOf } from 'type-fest'
import {
  getAddressConfigApiUrl,
  getIntroScreenGetApiUrl,
  getOTPConfigApiUrl,
  getStocksAccountConsentScreenGetApiUrl,
  getStocksAccountContentScreenPostApiUrl,
  getUserProfileGetApi,
  get_postUserProfileApi,
  postIvrDocDataApiUrl,
  postAddressConsentApiUrl,
  postRiskProfileApiUrl,
  postVerifyEmailOTPApiUrl,
  postVerifyOTPApiUrl,
  getEmployeeDetailsConfigApiUrl,
  getBrokerTnCConfigApiUrl,
  postStatusRequestApiUrl,
  postNomineeApiUrl,
  // getStocksAccountContentScreenPostApiUrl
} from './api-constants'
import {
  AccountIntroGetErrorResponse,
  AccountIntroGetSuccessResponse,
} from './api-types/account-intro'
import { AddressConfigApiType } from './api-types/address-config'
import {
  AddressConsentPostPayloadType,
  AddressConsentPostResponseType,
} from './api-types/post/address-consent'
import { CitizenDetailsUserProfilePayload } from './api-types/post/residence-details'
import {
  CKYCStatusUserProfilePayload,
  CKYCStatusUserProfileResponse,
} from './api-types/post/ckyc-status'
import {
  IvrDocDataPostPayloadType,
  IvrDocDataPostResponseType,
} from './api-types/post/ivr-doc-data'
import {
  PermanentAddressUserProfilePayload,
  PermanentAddressUserProfileResponse,
} from './api-types/post/permanent-address'
import {
  SbmRiskProfilePostPayloadType,
  SbmRiskProfilePostResponseType,
} from './api-types/post/sbm-risk-profile'
import {
  StocksAccountConsentPostPayloadType,
  StocksAccountConsentPostResponseType,
} from './api-types/post/stocks-account-consent'
import { StocksAccountConsentApiType } from './api-types/stocks-account-consent'
import { UserProfileGetResponseType } from './api-types/user-profile-get'
import kycGetGetter from './fetch-utils/get'
import kycPostGetter from './fetch-utils/post'
// import { getIntroScreenGetApiUrl } from './api-constants'
// import { NOT_LOGGED_IN } from './errors'

import type {} from // IvrFlowType,
'./types'
import {
  PersonalDetails1UserProfilePayload,
  PersonalDetailsUserProfileResponse,
} from './api-types/post/personal-details-1'

import { VerifyOtpApiType } from './api-types/verify-otp-config'
import {
  VerifySaveConsentPostPayloadType,
  VerifySaveConsentPostResponseType,
} from './api-types/post/save-consent'
import {
  VerifyEmailOTPPostPayloadType,
  VerifyEmailOTPPostResponseType,
} from './api-types/post/save-email-otp'
import { EmploymentDetailsConfigResponseType } from './api-types/employment-details'
import { PersonalDetails2UserProfilePayload } from './api-types/post/personal-details-2'
import { BrokerTnCConfigApiType } from './api-types/broker-tnc-config'
import {
  ConfirmPanPostPayload,
  ConfirmPanPostResponse,
} from './api-types/post/confirm-pan-post'
import {
  NomineeRelationPayload,
  NomineeRelationUserProfileResponse,
} from './api-types/post/nominee-relation'

export type UIDataType = {
  ACCOUNT_CREATION_INTRO: Promise<
    AccountIntroGetErrorResponse | AccountIntroGetSuccessResponse
  >
  STOCKS_ACCOUNT_CONSENT: Promise<StocksAccountConsentApiType>
  VERIFY_ADDRESS: Promise<AddressConfigApiType>
}

const notNeededPromiseGiver = () => Promise.resolve({ message: 'NO_NEED' })

export type NotRequiredType = typeof notRequiredResolvedValue
export const notRequiredResolvedValue = { message: 'NO_NEED' } as const
// save

export const kycConfig = {
  ACCOUNT_CREATION_INTRO: {
    uiDataGetHandler: kycGetGetter<
      AccountIntroGetErrorResponse | AccountIntroGetSuccessResponse
    >(getIntroScreenGetApiUrl),
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  STOCKS_ACCOUNT_CONSENT: {
    uiDataGetHandler: kycGetGetter<StocksAccountConsentApiType>(
      getStocksAccountConsentScreenGetApiUrl,
    ),
    postHandler: kycPostGetter<
      StocksAccountConsentPostResponseType,
      StocksAccountConsentPostPayloadType['body']
    >(getStocksAccountContentScreenPostApiUrl),
    userProfileGetHandler: notNeededPromiseGiver,
  },
  CHECK_KYC: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: kycPostGetter<
      CKYCStatusUserProfileResponse,
      CKYCStatusUserProfilePayload['body']
    >(get_postUserProfileApi),
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },
  CONFIRM_PAN: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: kycPostGetter<
      ConfirmPanPostResponse,
      ConfirmPanPostPayload['body']
    >(postStatusRequestApiUrl),
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },
  ENTER_PERSONAL_DETAILS_1: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: kycPostGetter<
      PersonalDetailsUserProfileResponse,
      PersonalDetails1UserProfilePayload['body']
    >(get_postUserProfileApi),
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },

  NOMINEE_RELATION: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: kycPostGetter<
      NomineeRelationUserProfileResponse,
      NomineeRelationPayload['body']
    >(postNomineeApiUrl),
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },

  ENTER_PERSONAL_DETAILS_2: {
    uiDataGetHandler: kycGetGetter<EmploymentDetailsConfigResponseType>(
      getEmployeeDetailsConfigApiUrl,
    ),
    postHandler: kycPostGetter<
      PersonalDetails2UserProfilePayload,
      PersonalDetails2UserProfilePayload['body']
    >(get_postUserProfileApi),
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },
  DIGIO: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  'ivr-screen': {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  PERMANENT_ADDRESS: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: kycPostGetter<
      PermanentAddressUserProfileResponse,
      PermanentAddressUserProfilePayload['body']
    >(get_postUserProfileApi),
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },

  ENTER_RESIDENCE_DETAILS: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: kycPostGetter<
      CitizenDetailsUserProfilePayload,
      CitizenDetailsUserProfilePayload['body']
    >(get_postUserProfileApi),
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },

  VERIFY_ADDRESS: {
    uiDataGetHandler: kycGetGetter<AddressConfigApiType>(
      getAddressConfigApiUrl,
    ),
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  SELFIE_CLICK: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  VERIFY_ADDRESS_DL: {
    uiDataGetHandler: () => Promise.resolve({ message: 'NO_NEED' }),
    postHandler: kycPostGetter<
      IvrDocDataPostResponseType,
      IvrDocDataPostPayloadType['body']
    >(postIvrDocDataApiUrl),
    userProfileGetHandler: notNeededPromiseGiver,
  },
  VERIFY_ADDRESS_PASSPORT: {
    uiDataGetHandler: () => Promise.resolve({ message: 'NO_NEED' }),
    postHandler: kycPostGetter<
      IvrDocDataPostResponseType,
      IvrDocDataPostPayloadType['body']
    >(postIvrDocDataApiUrl),
    userProfileGetHandler: notNeededPromiseGiver,
  },
  UPLOAD_DL_FRONT: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  UPLOAD_DL_BACK: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  UPLOAD_PASSPORT_FRONT: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  UPLOAD_PASSPORT_BACK: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  UPLOAD_PAN: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },
  ADDRESS_CONSENT: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: kycPostGetter<
      AddressConsentPostResponseType,
      AddressConsentPostPayloadType['body']
    >(postAddressConsentApiUrl),
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },
  SBM_RISK_PROFILE: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: kycPostGetter<
      SbmRiskProfilePostResponseType,
      SbmRiskProfilePostPayloadType['body']
    >(postRiskProfileApiUrl),
    userProfileGetHandler: notNeededPromiseGiver,
  },
  VERIFY_OTP: {
    uiDataGetHandler: kycGetGetter<VerifyOtpApiType>(getOTPConfigApiUrl),
    postHandler: kycPostGetter<
      VerifySaveConsentPostResponseType,
      VerifySaveConsentPostPayloadType['body']
    >(postVerifyOTPApiUrl),
    userProfileGetHandler: notNeededPromiseGiver,
  },
  STOCKS_ACCOUNT_STATUS: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  VERIFY_EMAIL: {
    uiDataGetHandler: () => Promise.resolve({ message: 'NO_NEED' }),
    postHandler: kycPostGetter<
      VerifyEmailOTPPostResponseType,
      VerifyEmailOTPPostPayloadType['body']
    >(postVerifyEmailOTPApiUrl),
    userProfileGetHandler:
      kycGetGetter<UserProfileGetResponseType>(getUserProfileGetApi),
  },
  USER_AGREEMENT: {
    uiDataGetHandler: kycGetGetter<BrokerTnCConfigApiType>(
      getBrokerTnCConfigApiUrl,
    ),
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  CURRENT_LOCATION: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
  KYCFLOW: {
    uiDataGetHandler: notNeededPromiseGiver,
    postHandler: notNeededPromiseGiver,
    userProfileGetHandler: notNeededPromiseGiver,
  },
}

export type AllKycScreenRouteNames = keyof typeof kycConfig

type AllScreensSelfDict = {
  [k in AllKycScreenRouteNames]: k
}
export const allKycScreenIds = Object.keys(
  kycConfig,
).reduce<AllScreensSelfDict>((acc, screenName) => {
  acc[screenName] = screenName
  return acc
  // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
}, {} as AllScreensSelfDict)

export type UnionAllKycGetDataHandlers = ValueOf<
  typeof kycConfig
>['uiDataGetHandler']

export type UIGetDataUnionType = ReturnType<
  (typeof kycConfig)[AllKycScreenRouteNames]['uiDataGetHandler']
>

export type PostDataUnionType = ReturnType<
  (typeof kycConfig)[AllKycScreenRouteNames]['postHandler']
>

export type UserProfileGetUnionType = ReturnType<
  (typeof kycConfig)[AllKycScreenRouteNames]['userProfileGetHandler']
>

export type AllPostPayLoadsIntersection =
  StocksAccountConsentPostPayloadType['body'] &
    CKYCStatusUserProfilePayload['body'] &
    IvrDocDataPostPayloadType['body'] &
    AddressConsentPostPayloadType['body'] &
    SbmRiskProfilePostPayloadType['body'] &
    PermanentAddressUserProfilePayload['body'] &
    CitizenDetailsUserProfilePayload['body'] &
    VerifySaveConsentPostPayloadType['body'] &
    VerifyEmailOTPPostPayloadType['body'] &
    PersonalDetails2UserProfilePayload['body'] &
    ConfirmPanPostPayload['body'] &
    NomineeRelationPayload['body']
